"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trigger = exports.ProductArea = exports.EventPrefix = void 0;
/**
 * Enum representing different event prefixes used in tracking.
 * This is typically static per product, but can change.
 */
var EventPrefix;
(function (EventPrefix) {
    EventPrefix["PATIENT_FUNNEL"] = "PatientFunnel";
    EventPrefix["MARKETING_SITE"] = "MKTG_Site";
    EventPrefix["PROVIDER_ACCESS"] = "ProviderAccess";
    EventPrefix["ONBOARDING_PORTAL"] = "OnboardingPortal";
    EventPrefix["PARTNER_INTEGRATION"] = "PartnerIntegration";
})(EventPrefix || (exports.EventPrefix = EventPrefix = {}));
/**
 * Enum representing different product areas.
 * This helps in categorizing events based on the product area they belong to.
 */
var ProductArea;
(function (ProductArea) {
    ProductArea["MARKETING_SITE"] = "Marketing Site";
    ProductArea["ENTRY_FORM"] = "Entry Form";
    ProductArea["BOOKING_UI"] = "Booking UI";
    ProductArea["ONBOARDING_UI"] = "Onboarding UI";
    ProductArea["REGISTRATION_FORM"] = "Registration Form";
    ProductArea["DIRECT_BOOKING_TOOL"] = "Direct Booking Tool";
    // used on booking-ui /providers
    ProductArea["PUBLIC_PROVIDER_PROFILES"] = "Public Provider Profiles";
    // used on booking-ui /therapists
    ProductArea["PROVIDER_DIRECTORY"] = "Provider Directory";
    ProductArea["PARTNER_INTEGRATION"] = "Partner Integration";
})(ProductArea || (exports.ProductArea = ProductArea = {}));
/**
 * Enum representing various types of triggers for events.
 *
 * @enum {string}
 *
 * @property {string} INTERACTION - Captures an interaction with an element on a page. More generic than a form submission or other specialized triggers.
 * @property {string} PAGE_LOAD - A page load event.
 * @property {string} SUBMISSION - Form submission.
 * @property {string} SUBMISSION_ERROR - Unexpected errors as a result of form submission.
 * @property {string} SUBMISSION_FEEDBACK - Any sort of feedback (success, warning, waiting, etc) shown to user as a result of a form submission.
 * @property {string} SERVER_ERROR - Catch-all for general unexpected errors.
 * @property {string} AUTOMATION - Some internal automation or tool was the cause of this event.
 *
 * @property {string} CREATE_REGISTRATION - A new registration link was created.
 * @property {string} EMAIL_CAPTURE - A user's email was captured.
 *
 * @property {string} OUTBOUND_LINK_CLICKED - Marketing site specific event trigger for an outbound link click.
 * @property {string} INTERNAL_LINK_CLICKED - Marketing site specific event trigger for an internal link click.
 * @property {string} ANCHOR_LINK_CLICKED - Marketing site specific event trigger for an anchor link click.
 * @property {string} AVOB_BANNER_CLICKED - Marketing site specific event trigger for an AVOB banner click.
 * @property {string} FORM_SUBMITTED - Marketing site specific event trigger for a form submission.
 * @property {string} FORM_INTERACTION - Marketing site specific event trigger for a form interaction.
 * @property {string} USER_GROUP - Marketing site specific event trigger for a user group.
 */
var Trigger;
(function (Trigger) {
    /**
     * General event triggers. Choose from this list first
     */
    Trigger["INTERACTION"] = "Interaction";
    Trigger["PAGE_LOAD"] = "PageLoad";
    Trigger["SUBMISSION"] = "Submission";
    Trigger["SUBMISSION_ERROR"] = "SubmissionError";
    Trigger["SUBMISSION_FEEDBACK"] = "SubmissionFeedback";
    Trigger["SERVER_ERROR"] = "ServerError";
    Trigger["AUTOMATION"] = "Automation";
    /**
     * Specialized event triggers
     */
    Trigger["CREATE_REGISTRATION"] = "CreateRegistration";
    Trigger["EMAIL_CAPTURE"] = "EmailCapture";
    // Marketing site specific event triggers
    Trigger["OUTBOUND_LINK_CLICKED"] = "Outbound_link_clicked";
    Trigger["INTERNAL_LINK_CLICKED"] = "Internal_link_clicked";
    Trigger["ANCHOR_LINK_CLICKED"] = "Anchor_link_clicked";
    Trigger["AVOB_BANNER_CLICKED"] = "avob_banner_clicked";
    Trigger["FORM_SUBMITTED"] = "Form_submitted";
    Trigger["FORM_INTERACTION"] = "Form_Interaction";
    Trigger["USER_GROUP"] = "user_group";
    Trigger["CONTENT_DOWNLOAD"] = "Content_Download";
})(Trigger || (exports.Trigger = Trigger = {}));
//# sourceMappingURL=track.js.map